module.exports = __webpack_public_path__ + "img/751.cef3178a.jpg";